import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-sim-data-details',
  templateUrl: './sim-data-details.component.html',
  styleUrls: ['./sim-data-details.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    DatePipe,
    MatIcon,
    MatTooltip,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class SimDataDetailsComponent implements OnInit {
  listOfBatch = [];
  totalLength = 0;
  size = 10;
  page = 1;
  search = '';
  simStatusType = '';
  activationStatusType = '';
  simDataDetailsForm: FormGroup = this.formBuilder.group({});
  reportsSIMDetailsForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  simDetailView = false;

  simStatusList = [
    {
      simStatusName: 'Active',
      simStatusValue: 'Active',
    },
    {
      simStatusName: 'Inactive',
      simStatusValue: 'Inactive',
    },
  ];

  activationStatusList = [
    {
      activationStatusName: 'Commercial',
      activationStatusValue: 'Commercial',
    },
    {
      activationStatusName: 'Inactive',
      activationStatusValue: 'Inactive',
    },
  ];

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setSIMDetailsLogForm();
    this.setReportsSIMDetailsLogForm();
    if (this.simDetailView) {
      this.fetchList();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'SIM Data Details' && element.view === false) {
          this.navigateBack();
        } else if (
          element.pageName === 'SIM Data Details' &&
          element.view === true
        ) {
          this.simDetailView = true;
        }
      }
    );
  }

  setSIMDetailsLogForm() {
    this.simDataDetailsForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  setReportsSIMDetailsLogForm() {
    this.reportsSIMDetailsForm = this.formBuilder.group({
      activationStatusType: new FormControl(''),
      simStatusType: new FormControl(''),
    });
  }

  fetchList() {
    this.spinner.show();
    this.simStatusType = this.reportsSIMDetailsForm.get('simStatusType')?.value;
    this.activationStatusType = this.reportsSIMDetailsForm.get(
      'activationStatusType'
    )?.value;
    this.listOfBatch = [];
    this.apiMicroservice
      .getSimDataDetails(
        this.page,
        this.size,
        this.search,
        this.simStatusType,
        this.activationStatusType
      )
      .subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.listOfBatch = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar(res.message);
        } else {
          this.apiMicroservice.openSnackbar(
            res.message ? res.message : 'Something went wrong'
          );
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.search = event;
    this.simDataDetailsForm
      ?.get('batchListSearch')
      ?.setValue(this.search ? this.search : '');
    this.fetchList();
  }

  clear() {
    this.reportsSIMDetailsForm.reset();
    this.reportsSIMDetailsForm.controls['activationStatusType'].setValue('');
    this.reportsSIMDetailsForm.controls['simStatusType'].setValue('');
    this.page = 1;
    this.fetchList();
  }

  // Export Functions
  DownloadOutputReport() {
    this.spinner.show();
    this.apiMicroservice.getSimDataDetailsExport().subscribe({
      next: (res) => {
        if (res?.status && res.fileDownloadUrl) {
          const link = document.createElement('a');
          link.href = res.fileDownloadUrl;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.apiMicroservice.openSnackbar('File ready for download');
        } else {
          this.apiMicroservice.openSnackbar(
            res?.message || 'File URL not available'
          );
        }
        this.spinner.hide();
      },
      error: () => {
        this.apiMicroservice.openSnackbar(
          'Download failed. Please contact server team.'
        );
        this.spinner.hide();
      },
    });
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
